import * as React from 'react';
import PropTypes from 'prop-types';
var SvgSportsWeightTrainingNormalSmall = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23.41 11.71H22.1V10a1 1 0 00-1-1h-1.39v-.86a1 1 0 00-1-1h-1.38a1 1 0 00-1 1v3.57H7.67V8.14a1 1 0 00-1-1H5.28a1 1 0 00-1 1v.91H2.9a1 1 0 00-1 1v1.67H.59a.5.5 0 00-.5.5.51.51 0 00.5.5H1.9v1.8a1 1 0 001 1h1.39v1a1 1 0 001 1h1.38a1 1 0 001-1v-3.81h8.66v3.78a1 1 0 001 1h1.39a1 1 0 001-1v-1h1.38a1 1 0 001-1v-1.8h1.31a.51.51 0 00.5-.5.5.5 0 00-.5-.48zM2.9 14.51v-4.46h1.39v4.47zm2.39 2V8.15h1.38v8.35zm12 0V8.15h1.38v8.32zm2.38-2v-4.46h1.43v4.47z"
  }));
});
SvgSportsWeightTrainingNormalSmall.defaultProps = {
  height: 24,
  width: 24
};
SvgSportsWeightTrainingNormalSmall.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgSportsWeightTrainingNormalSmall;